module.exports = __webpack_public_path__ + "img/objArrowRight.d6e119f5.svg";